import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import { CommandBarButton, MessageBarType } from "office-ui-fabric-react";
import Actions from "../../../../redux/Actions";
import { DurableFunctionInstance } from "../../../../models/DurableFunctionInstance";
import MailroomDurableFunctionInstanceList from "../../../mailroom/MailroomDurableFunctionInstanceList";
import MailroomSchool from "../../../mailroom/MailroomSchool";
import SchoolPageTitle from "../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../AdminSchoolMenu";

interface SalamanderProcessorPageProps {
    tenantId: string;
    schoolCode: string;

    apiService: ApiService;
}

interface SalamanderProcessorPageState {
    instanceRecords: DurableFunctionInstance[] | undefined;
}

class SalamanderProcessorPage extends Component<SalamanderProcessorPageProps & DispatchProps, SalamanderProcessorPageState> {

    constructor(props: SalamanderProcessorPageProps & DispatchProps) {
        super(props);

        this.state = {
            instanceRecords: undefined
        };
    }

    async componentDidUpdate(prevProps: Readonly<SalamanderProcessorPageProps & DispatchProps>, prevState: Readonly<SalamanderProcessorPageState>, snapshot?: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.loadInstanceRecords(this.props.tenantId, this.props.schoolCode);
        }

    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.loadInstanceRecords(this.props.tenantId, this.props.schoolCode);
        }
    }

    private async loadInstanceRecords(tenantId: string, schoolCode: string) {
        this.setState({
            instanceRecords: undefined
        });

        const records = await this.props.apiService.getSchoolsMailroomFunctionInstances(tenantId, schoolCode, "ProcessorOrchestration");

        this.setState({
            instanceRecords: records
        });
    }
    
    private startProcessor = async () => {
        try {
            await this.props.apiService.triggerMailroomProcessor(this.props.tenantId, this.props.schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Successfully started processor`, MessageBarType.success));
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error starting processor`, MessageBarType.error));
        }
        
        await this.loadInstanceRecords(this.props.tenantId,this.props.schoolCode);
    }
    
    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Processors" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <MailroomSchool schoolCode={this.props.schoolCode} tenantId={this.props.tenantId} />
                <MailroomDurableFunctionInstanceList title={"Processor Instances"} columns={MailroomDurableFunctionInstanceList.processorColumns} additionalCellForColumn={MailroomDurableFunctionInstanceList.processorAdditionalCellForColumn} enableRowLinks={true} instances={this.state.instanceRecords} linkForInstance={(dfi) => `/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/process/${dfi.durableFunctionInstanceId}`}>
                    <CommandBarButton
                        iconProps={{ iconName: "play" }}
                        text="Start Processor"
                        onClick={this.startProcessor}
                    />
                </MailroomDurableFunctionInstanceList>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): SalamanderProcessorPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,

            apiService: state.auth.apiService
        };
    }
)(SalamanderProcessorPage);